import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  BvsHaftpflichtUndKaskoBoatInformationFormModel,
  BvsHaftpflichtUndKaskoFiguresFormModel,
  BvsHaftpflichtUndKaskoFormModel
} from '../models/form/bvs-haftpflicht-und-kasko-form.model';
import { createCustomerDataForm } from '@shared/factories/customer-form.factory';
import { createBvsFiguresBaseForm } from '@shared/factories/bvs-figures-base.factory';
import { createBvsBoatInformationBaseForm } from '@shared/factories/bvs-boat-information-form.factory';
import { BoatHullMaterial, CallidusBvsSelbstbehaltKunde } from '@backend/models';
import { DateValidator } from '@shared/validators/date.validator';

export function createBvsHaftpflichtKaskoForm(): FormGroup<BvsHaftpflichtUndKaskoFormModel> {
  return new FormGroup<BvsHaftpflichtUndKaskoFormModel>({
    bvsBoatInformation: new FormGroup<BvsHaftpflichtUndKaskoBoatInformationFormModel>(createBvsBoatInformationHaftpflichtKaskoForm()),
    bvsFigures: new FormGroup<BvsHaftpflichtUndKaskoFiguresFormModel>(createBvsFiguresHaftpflichtKaskoForm()),
    customerData: createCustomerDataForm()
  });
}

function createBvsBoatInformationHaftpflichtKaskoForm(): BvsHaftpflichtUndKaskoBoatInformationFormModel {
  const commonForm = createBvsBoatInformationBaseForm();
  return {
    ...commonForm,
    isSport: new FormControl<boolean | null>(null),
    isBoatModified: new FormControl<boolean | null>(null),
    boatModifiedValue: new FormControl<string | null>(null),
    constructionYear: new FormControl<number | null>(null, [
      DateValidator.minDate(new Date(1900, 0, 1)),
      DateValidator.maxDate(new Date()),
      Validators.required
    ]),
    hullMaterial: new FormControl<BoatHullMaterial | null>(null, Validators.required),
    fullWidth: new FormControl<number | null>(null),
    fullLength: new FormControl<number | null>(null)
  };
}

function createBvsFiguresHaftpflichtKaskoForm(): BvsHaftpflichtUndKaskoFiguresFormModel {
  const commonForm = createBvsFiguresBaseForm();

  return {
    ...commonForm,
    selbstbehaltKunde: new FormControl<CallidusBvsSelbstbehaltKunde | null>(null, Validators.required),
    isMaschinendeckung: new FormControl<boolean | null>(false),
    insuranceSumBoat: new FormControl<number | null>(null),
    insuranceSumAdditionalEquipment: new FormControl<number | null>(null),
    insuranceSumPersoenlicheEffekte: new FormControl<number | null>(null),
    insuranceSumTrailer: new FormControl<number | null>(null),
    insuranceSumDinghy: new FormControl<number | null>(null),
    totalInsuranceSum: new FormControl<number | null>(null),
    allPricesWithVAT: new FormControl<boolean | null>(null)
  };
}
